import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShopState } from '../_state/shop/shop.state';

@Injectable({ providedIn: 'root' })
export class ShopCapabilityService {
  constructor(private store: Store) {}

  get hasFbtAccess(): boolean {
    const shop = this.store.selectSnapshot(ShopState.activeShop);
    return shop?.capabilities?.fbt_access?.status === 'granted';
  }

  hasCapability(key: string): boolean {
    const shop = this.store.selectSnapshot(ShopState.activeShop);
    const cap = (shop?.capabilities as Record<string, { status: string }> | undefined)?.[key];
    return cap?.status === 'granted';
  }
}
